<template>
  <div class="bg-white border border-2 rounded mb-5 d-flex align-items-center" style="height:70px" :class="[` border-${variant}`]">
    <span v-if="icon" class="text-center" style="width: 60px">
      <i class="fa-fw fa-2x" :class="[icon, `text-${variant}`]"></i>
    </span>
    <div class="p-3 w-100">
      <h6 class="mb-1">{{ title }}</h6>
      <h4 class="m-0">
        <strong>{{ amount }}</strong>
      </h4>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: "primary",
    },
    icon: String,
    title: String,
    amount: [String, Number],
  },
};
</script>

<style></style>
